import { render } from "./BaseModalWithoutLine.vue?vue&type=template&id=637297b0"
import script from "./BaseModalWithoutLine.vue?vue&type=script&lang=js"
export * from "./BaseModalWithoutLine.vue?vue&type=script&lang=js"
script.render = render

export default script